import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    templateUrl: './no-access.component.html',
    styleUrls: ['./no-access.component.scss'],
        imports: [
        TranslateModule
    ]
})
export class NoAccessComponent { }